t = require('views/internal/teacup-with-helpers')('header_enterprise_admin_dashboard__menu')

module.exports = t.renderable (links) ->
  t.ul '.pop-over-list', ->
    for link in links
      t.li ->
        t.a href: link.url, ->
          t.text link.title



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_enterprise_admin_dashboard_menu.coffee